import React from 'react';
import {Timer, Trophy, ListChecks} from 'lucide-react';
import DemoPlaceholder from './DemoPlaceholder';
import section from '../../styles/components/sections.module.css';
import styles from '../../styles/components/GameModesSection.module.css';

const modes = [
  {
    icon: Timer,
    title: 'Timed Challenge',
    description: 'Race against the clock in 1, 3, or 5 minute rounds. Three difficulty levels: Easy, Medium, and Hard.',
  },
  {
    icon: Trophy,
    title: 'Grand Challenge',
    description: 'The ultimate test. No time limit, but increasing difficulty. How far can you go?',
  },
  {
    icon: ListChecks,
    title: '100 Questions',
    description: 'Answer 100 questions as fast as possible. Speed and accuracy both matter.',
  },
];

const GameModesSection: React.FC = () => {
  return (
    <section className={`${section.section} ${section.sectionAlt}`}>
      <div className={section.container}>
        <h2 className={section.title}>Multiple Game Modes</h2>
        <p className={section.subtitle}>Choose your challenge and compete on dedicated leaderboards.</p>
        <div className={styles.grid}>
          {modes.map((mode) => (
            <div className={styles.card} key={mode.title}>
              <mode.icon size={32} className={styles.cardIcon} />
              <h3 className={styles.cardTitle}>{mode.title}</h3>
              <p className={styles.cardDescription}>{mode.description}</p>
              <DemoPlaceholder aspectRatio="4 / 3" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GameModesSection;
